module.exports = __webpack_public_path__ + "media/images/tutorial_body_sp1-01-f598c404d9ba81e1f860db6496b51b50.png";